// https://www.artlebedev.ru/country-list/
var _a, _b, _c, _d, _e, _f;
export var PHRASES;
(function (PHRASES) {
    PHRASES[PHRASES["New_Game"] = 0] = "New_Game";
    PHRASES[PHRASES["Continue"] = 1] = "Continue";
    PHRASES[PHRASES["Learning"] = 2] = "Learning";
    PHRASES[PHRASES["step"] = 3] = "step";
    PHRASES[PHRASES["of"] = 4] = "of";
    PHRASES[PHRASES["Excellent"] = 5] = "Excellent";
    PHRASES[PHRASES["Line_up_the_puzzle_horizontally"] = 6] = "Line_up_the_puzzle_horizontally";
    PHRASES[PHRASES["Line_up_the_puzzle_vertically"] = 7] = "Line_up_the_puzzle_vertically";
    PHRASES[PHRASES["Make_a_square"] = 8] = "Make_a_square";
    PHRASES[PHRASES["CLICK_TO_SHAPE"] = 9] = "CLICK_TO_SHAPE";
    PHRASES[PHRASES["You_are_ready_to_play"] = 10] = "You_are_ready_to_play";
    PHRASES[PHRASES["MOVE_SHAPES_TO_GOOD_SCORE"] = 11] = "MOVE_SHAPES_TO_GOOD_SCORE";
    PHRASES[PHRASES["OCCUPIED_CELLS_ARE_VACATED"] = 12] = "OCCUPIED_CELLS_ARE_VACATED";
    PHRASES[PHRASES["SHAPES_CAN_BE_TURNED"] = 13] = "SHAPES_CAN_BE_TURNED";
    PHRASES[PHRASES["Play"] = 14] = "Play";
    PHRASES[PHRASES["Block_Puzzle"] = 15] = "Block_Puzzle";
    PHRASES[PHRASES["The_hints_are_over"] = 16] = "The_hints_are_over";
    PHRASES[PHRASES["COME_BACK_FOR_BONUS"] = 17] = "COME_BACK_FOR_BONUS";
    PHRASES[PHRASES["BONUS_ACCRUED"] = 18] = "BONUS_ACCRUED";
    PHRASES[PHRASES["New_Record"] = 19] = "New_Record";
    PHRASES[PHRASES["NEW_RECORD"] = 20] = "NEW_RECORD";
    PHRASES[PHRASES["Score"] = 21] = "Score";
    PHRASES[PHRASES["video"] = 22] = "video";
    PHRASES[PHRASES["Color_Theme"] = 23] = "Color_Theme";
    PHRASES[PHRASES["Language"] = 24] = "Language";
    PHRASES[PHRASES["Global_Rating"] = 25] = "Global_Rating";
    PHRASES[PHRASES["Sound_Effects"] = 26] = "Sound_Effects";
    PHRASES[PHRASES["ComboAnimations"] = 27] = "ComboAnimations";
    PHRASES[PHRASES["CancelMoveFeature"] = 28] = "CancelMoveFeature";
    PHRASES[PHRASES["CancelMove"] = 29] = "CancelMove";
    PHRASES[PHRASES["theme_default"] = 30] = "theme_default";
    PHRASES[PHRASES["theme_old_school"] = 31] = "theme_old_school";
    PHRASES[PHRASES["theme_night"] = 32] = "theme_night";
    PHRASES[PHRASES["theme_instagram"] = 33] = "theme_instagram";
    PHRASES[PHRASES["theme_green_lantern"] = 34] = "theme_green_lantern";
    PHRASES[PHRASES["theme_white"] = 35] = "theme_white";
    // invite_friends,
    PHRASES[PHRASES["Friends_achievements"] = 36] = "Friends_achievements";
    PHRASES[PHRASES["lang_ru"] = 37] = "lang_ru";
    PHRASES[PHRASES["lang_en"] = 38] = "lang_en";
    PHRASES[PHRASES["lang_tr"] = 39] = "lang_tr";
    PHRASES[PHRASES["lang_es"] = 40] = "lang_es";
    PHRASES[PHRASES["lang_de"] = 41] = "lang_de";
    PHRASES[PHRASES["lang_hi"] = 42] = "lang_hi";
    PHRASES[PHRASES["Rating"] = 43] = "Rating";
    PHRASES[PHRASES["Loading"] = 44] = "Loading";
    PHRASES[PHRASES["Something_went_wrong"] = 45] = "Something_went_wrong";
    PHRASES[PHRASES["Authorization_required_in_rating"] = 46] = "Authorization_required_in_rating";
    PHRASES[PHRASES["Login"] = 47] = "Login";
    PHRASES[PHRASES["Anonymous_player"] = 48] = "Anonymous_player";
    PHRASES[PHRASES["Try_again"] = 49] = "Try_again";
    PHRASES[PHRASES["You_can_cancel_moves_for_rw"] = 50] = "You_can_cancel_moves_for_rw";
    PHRASES[PHRASES["You_can_cancel_this_move_for_rw"] = 51] = "You_can_cancel_this_move_for_rw";
    PHRASES[PHRASES["You_can_cancel_this_move_for_coins"] = 52] = "You_can_cancel_this_move_for_coins";
    // You_can_get_coins_for_rv,
    PHRASES[PHRASES["You_need_replenish_balance"] = 53] = "You_need_replenish_balance";
    PHRASES[PHRASES["No_RW_message"] = 54] = "No_RW_message";
    PHRASES[PHRASES["Close_after_x_sec"] = 55] = "Close_after_x_sec";
    PHRASES[PHRASES["Last_x_moves_canceled"] = 56] = "Last_x_moves_canceled";
    PHRASES[PHRASES["All_time_record"] = 57] = "All_time_record";
    PHRASES[PHRASES["Combo_x"] = 58] = "Combo_x";
    PHRASES[PHRASES["Series_x"] = 59] = "Series_x";
    PHRASES[PHRASES["HIGH_SCORE_1"] = 60] = "HIGH_SCORE_1";
    PHRASES[PHRASES["HIGH_SCORE_2"] = 61] = "HIGH_SCORE_2";
    PHRASES[PHRASES["HIGH_SCORE_TODAY_1"] = 62] = "HIGH_SCORE_TODAY_1";
    PHRASES[PHRASES["HIGH_SCORE_TODAY_2"] = 63] = "HIGH_SCORE_TODAY_2";
    PHRASES[PHRASES["Cancel"] = 64] = "Cancel";
    PHRASES[PHRASES["Close"] = 65] = "Close";
    PHRASES[PHRASES["You_can_get_hint_for_rw"] = 66] = "You_can_get_hint_for_rw";
    PHRASES[PHRASES["Bonus_x_hints"] = 67] = "Bonus_x_hints";
    PHRASES[PHRASES["Bonus_x_coins"] = 68] = "Bonus_x_coins";
    // DailyBonus
    PHRASES[PHRASES["DailyBonus"] = 69] = "DailyBonus";
    PHRASES[PHRASES["Come_back"] = 70] = "Come_back";
    PHRASES[PHRASES["You_have_daily_bonus"] = 71] = "You_have_daily_bonus";
    PHRASES[PHRASES["Take"] = 72] = "Take";
    PHRASES[PHRASES["You_have_access_to_bonus_for_x_days"] = 73] = "You_have_access_to_bonus_for_x_days";
    PHRASES[PHRASES["DaysPlural"] = 74] = "DaysPlural";
    PHRASES[PHRASES["Ok"] = 75] = "Ok";
    PHRASES[PHRASES["Store"] = 76] = "Store";
    PHRASES[PHRASES["Rewarded_video"] = 77] = "Rewarded_video";
    PHRASES[PHRASES["Settings"] = 78] = "Settings";
    PHRASES[PHRASES["VERSION"] = 79] = "VERSION";
    PHRASES[PHRASES["Show_rv"] = 80] = "Show_rv";
    PHRASES[PHRASES["Please_try_again_later"] = 81] = "Please_try_again_later";
    PHRASES[PHRASES["SMALL_SCREEN"] = 82] = "SMALL_SCREEN";
    PHRASES[PHRASES["native_timer_text"] = 83] = "native_timer_text";
})(PHRASES || (PHRASES = {}));
var ru = (_a = {},
    _a[PHRASES.New_Game] = 'Новая игра',
    _a[PHRASES.Continue] = 'Продолжить',
    _a[PHRASES.Learning] = 'Обучение',
    _a[PHRASES.step] = 'шаг',
    _a[PHRASES.of] = 'из',
    _a[PHRASES.Excellent] = 'Отлично',
    _a[PHRASES.Line_up_the_puzzle_horizontally] = 'Соберите горизонтальную линию.',
    _a[PHRASES.Line_up_the_puzzle_vertically] = 'Соберите вертикальную линию.',
    _a[PHRASES.Make_a_square] = 'Соберите квадрат.',
    _a[PHRASES.CLICK_TO_SHAPE] = 'Поверните фигуру, кликнув по ней.',
    _a[PHRASES.You_are_ready_to_play] = 'Вы готовы к игре.',
    _a[PHRASES.MOVE_SHAPES_TO_GOOD_SCORE] = 'Чтобы набрать больше очков, перетащите на игровое поле как можно больше фигурок.',
    _a[PHRASES.OCCUPIED_CELLS_ARE_VACATED] = 'Занятые клетки освобождаются, когда заполняется вертикальная/горизонтальная линия или один из 9 квадратов.',
    _a[PHRASES.SHAPES_CAN_BE_TURNED] = 'Фигурки можно вращать кликая по ним.',
    _a[PHRASES.Play] = 'Играть',
    _a[PHRASES.Block_Puzzle] = FOR_VK ? 'Судоку Пазл' : 'ТуДоКу',
    _a[PHRASES.The_hints_are_over] = 'Подсказки закончились.',
    _a[PHRASES.COME_BACK_FOR_BONUS] = 'Возвращайтесь в игру завтра, чтобы получить бонус.',
    _a[PHRASES.BONUS_ACCRUED] = 'Начислен бонус в размере %bonus% подсказок за регулярный ежедневный вход в игру.',
    _a[PHRASES.New_Record] = 'Новый рекорд',
    _a[PHRASES.NEW_RECORD] = 'НОВЫЙ РЕКОРД',
    _a[PHRASES.Score] = 'Счёт',
    _a[PHRASES.video] = 'видео',
    _a[PHRASES.Color_Theme] = 'Тема',
    _a[PHRASES.Language] = 'Язык',
    _a[PHRASES.Global_Rating] = 'Общий рейтинг',
    _a[PHRASES.Sound_Effects] = 'Звуковые эффекты',
    _a[PHRASES.ComboAnimations] = 'Анимации (Комбо/Серия)',
    _a[PHRASES.CancelMoveFeature] = 'Функция отмены хода',
    _a[PHRASES.CancelMove] = 'Отменить ход',
    _a[PHRASES.theme_default] = 'Стандартная',
    _a[PHRASES.theme_old_school] = 'Старая школа',
    _a[PHRASES.theme_night] = 'Ночная',
    _a[PHRASES.theme_instagram] = FOR_VK ? 'Нельзяграм' : 'Инстаграм',
    _a[PHRASES.theme_green_lantern] = 'Зеленый фонарь',
    _a[PHRASES.theme_white] = 'Светлая',
    // [PHRASES.invite_friends]: 'Пригласить друзей',
    _a[PHRASES.Friends_achievements] = 'Достижения друзей',
    _a[PHRASES.lang_ru] = 'Русский',
    _a[PHRASES.lang_en] = 'Английский',
    _a[PHRASES.lang_tr] = 'Турецкий',
    _a[PHRASES.lang_es] = 'Испанский',
    _a[PHRASES.lang_de] = 'Немецкий',
    _a[PHRASES.lang_hi] = 'Хинди',
    _a[PHRASES.Rating] = 'Рейтинг',
    _a[PHRASES.Loading] = 'Загрузка',
    _a[PHRASES.Something_went_wrong] = 'Что-то пошло не так.',
    _a[PHRASES.Authorization_required_in_rating] = 'Для просмотра рейтинга нужно авторизоваться.',
    _a[PHRASES.Login] = 'Вход',
    _a[PHRASES.Anonymous_player] = 'Анонимный игрок',
    // [PHRASES.Try_again]: 'Попробовать снова',
    _a[PHRASES.You_can_cancel_moves_for_rw] = 'Вы можете отменить несколько ходов за просмотр рекламного видео.',
    _a[PHRASES.You_can_cancel_this_move_for_rw] = 'Вы можете отменить этот ход за просмотр рекламного видео.',
    _a[PHRASES.You_can_cancel_this_move_for_coins] = 'Вы можете отменить этот ход за $1 монет.',
    // [PHRASES.You_can_get_coins_for_rv]:
    // 'Недостаточно монет для отмены хода. Вы можете получить дополнительные монеты посмотрев рекламное видео.',
    _a[PHRASES.You_need_replenish_balance] = 'Необходимо пополнить баланс, чтобы воспользоваться функциями отмены хода или подсказки.',
    _a[PHRASES.No_RW_message] = 'Извините. В данный момент нет доступных рекламных видео.',
    _a[PHRASES.Close_after_x_sec] = 'Закрытие через $1 сек',
    _a[PHRASES.Last_x_moves_canceled] = 'Было отменено $1 последних ходов.',
    _a[PHRASES.All_time_record] = 'Рекорд',
    _a[PHRASES.Combo_x] = 'Комбо $1x!',
    _a[PHRASES.Series_x] = 'Серия $1x!',
    _a[PHRASES.HIGH_SCORE_1] = 'НОВЫЙ АБСОЛЮТНЫЙ',
    _a[PHRASES.HIGH_SCORE_2] = 'РЕКОРД',
    _a[PHRASES.HIGH_SCORE_TODAY_1] = 'ЛУЧШИЙ РЕЗУЛЬТАТ',
    _a[PHRASES.HIGH_SCORE_TODAY_2] = 'ЗА СЕГОДНЯ',
    _a[PHRASES.Cancel] = 'Отмена',
    _a[PHRASES.Close] = 'Закрыть',
    _a[PHRASES.You_can_get_hint_for_rw] = 'Вы можете получить дополнительные подсказки за просмотр рекламного видео.',
    _a[PHRASES.Bonus_x_hints] = 'Бонус: $1 подсказок',
    _a[PHRASES.Bonus_x_coins] = 'Бонус: $1 монет',
    // DailyBonus
    _a[PHRASES.DailyBonus] = 'Дневной бонус',
    _a[PHRASES.Come_back] = 'Возвращайтесь в игру завтра чтобы получить бонус.',
    _a[PHRASES.Try_again] = 'Пробовать снова',
    _a[PHRASES.You_have_daily_bonus] = 'Вам доступен бонус за регулярный вход в игру. Хотите посмотреть?',
    _a[PHRASES.Take] = 'Забрать',
    _a[PHRASES.You_have_access_to_bonus_for_x_days] = 'Вам доступен бонус за $1.',
    _a[PHRASES.DaysPlural] = 'день|дня|дней',
    _a[PHRASES.Ok] = 'Ok',
    _a[PHRASES.Store] = 'Магазин',
    _a[PHRASES.Rewarded_video] = 'Видео с вознаграждением.',
    _a[PHRASES.Settings] = 'Настройки',
    _a[PHRASES.VERSION] = 'Версия',
    _a[PHRASES.Show_rv] = 'Посмотреть рекламу',
    _a[PHRASES.Please_try_again_later] = 'Пожалуйста, попробуйте повторить запрос позднее.',
    _a[PHRASES.SMALL_SCREEN] = ['Извините! Для этой игры', 'нужен экран побольше.'],
    _a[PHRASES.native_timer_text] = 'Реклама через $t сек.',
    _a);
var en = (_b = {},
    _b[PHRASES.New_Game] = 'New Game',
    _b[PHRASES.Continue] = 'Continue',
    _b[PHRASES.Learning] = 'Learning',
    _b[PHRASES.step] = 'step',
    _b[PHRASES.of] = 'of',
    _b[PHRASES.Excellent] = 'Excellent',
    _b[PHRASES.Line_up_the_puzzle_horizontally] = 'Line up the puzzle horizontally',
    _b[PHRASES.Line_up_the_puzzle_vertically] = 'Line up the puzzle vertically',
    _b[PHRASES.Make_a_square] = 'Make a square',
    _b[PHRASES.CLICK_TO_SHAPE] = 'You should click a mouse to turn this shape',
    _b[PHRASES.You_are_ready_to_play] = 'You are ready to play',
    _b[PHRASES.MOVE_SHAPES_TO_GOOD_SCORE] = 'You should move a lot of shapes onto the playing field to turn in a good score',
    _b[PHRASES.OCCUPIED_CELLS_ARE_VACATED] = 'The occupied cells are vacated when the vertical/ horizontal line or one of the square is filled.',
    _b[PHRASES.SHAPES_CAN_BE_TURNED] = 'This shapes can be turned around when you click on them',
    _b[PHRASES.Play] = 'Play',
    _b[PHRASES.Block_Puzzle] = 'Block Puzzle',
    _b[PHRASES.The_hints_are_over] = 'The hints are over.',
    _b[PHRASES.COME_BACK_FOR_BONUS] = 'Come back to the game tomorrow for a bonus.',
    _b[PHRASES.BONUS_ACCRUED] = 'A bonus in the amount of %bonus% of hints for regular, daily login into the game has been accrued.',
    _b[PHRASES.New_Record] = 'New Record',
    _b[PHRASES.NEW_RECORD] = 'NEW RECORD',
    _b[PHRASES.Score] = 'Score',
    _b[PHRASES.video] = 'video',
    _b[PHRASES.Color_Theme] = 'Theme',
    _b[PHRASES.Language] = 'Language',
    _b[PHRASES.Global_Rating] = 'Overall rating',
    _b[PHRASES.Sound_Effects] = 'Sound Effects',
    _b[PHRASES.ComboAnimations] = 'Animations (Combo/Series)',
    _b[PHRASES.CancelMoveFeature] = 'Cancel Move',
    _b[PHRASES.CancelMove] = 'Undo move',
    _b[PHRASES.theme_default] = 'Default',
    _b[PHRASES.theme_old_school] = 'Old School',
    _b[PHRASES.theme_night] = 'Night',
    _b[PHRASES.theme_instagram] = 'Instagram',
    _b[PHRASES.theme_green_lantern] = 'Green Lantern',
    _b[PHRASES.theme_white] = 'White',
    // [PHRASES.invite_friends]: 'Invite friends',
    _b[PHRASES.Friends_achievements] = 'Friends achievements',
    _b[PHRASES.lang_ru] = 'Russian',
    _b[PHRASES.lang_en] = 'English',
    _b[PHRASES.lang_tr] = 'Turkish',
    _b[PHRASES.lang_es] = 'Spanish',
    _b[PHRASES.lang_de] = 'Deutsch',
    _b[PHRASES.lang_hi] = 'Hindi',
    _b[PHRASES.Rating] = 'Rating',
    _b[PHRASES.Loading] = 'Loading',
    _b[PHRASES.Something_went_wrong] = 'Something went wrong.',
    _b[PHRASES.Authorization_required_in_rating] = 'To view the rating you need to log in.',
    _b[PHRASES.Login] = 'Login',
    _b[PHRASES.Anonymous_player] = 'Anonymous player',
    // [PHRASES.Try_again]: 'Try again',
    _b[PHRASES.You_can_cancel_moves_for_rw] = 'You can undo multiple moves by watching a promotional video.',
    _b[PHRASES.You_can_cancel_this_move_for_rw] = 'You can cancel this move by watching the promotional video.',
    _b[PHRASES.You_can_cancel_this_move_for_coins] = 'You can cancel this move for $1 coins.',
    // [PHRASES.You_can_get_coins_for_rv]:
    // 'Not enough coins to cancel the move. You can get extra coins by watching the promotional video.',
    _b[PHRASES.You_need_replenish_balance] = 'You need to replenish the balance to use the undo or hint functions.',
    _b[PHRASES.No_RW_message] = 'Sorry. There are currently no promotional videos available.',
    _b[PHRASES.Close_after_x_sec] = 'Closing after $1 sec',
    _b[PHRASES.Last_x_moves_canceled] = 'The last $1 moves have been canceled.',
    _b[PHRASES.All_time_record] = 'All time',
    _b[PHRASES.Combo_x] = 'Combo $1x!',
    _b[PHRASES.Series_x] = 'Series $1x!',
    _b[PHRASES.HIGH_SCORE_1] = 'HIGH SCORE',
    _b[PHRASES.HIGH_SCORE_2] = '',
    _b[PHRASES.HIGH_SCORE_TODAY_1] = 'HIGH SCORE TODAY',
    _b[PHRASES.HIGH_SCORE_TODAY_2] = '',
    _b[PHRASES.Cancel] = 'Cancel',
    _b[PHRASES.Close] = 'Close',
    _b[PHRASES.You_can_get_hint_for_rw] = 'You can get additional hints for watching the promotional video.',
    _b[PHRASES.Bonus_x_hints] = 'Bonus: $1 hints',
    _b[PHRASES.Bonus_x_coins] = 'Bonus: $1 coins',
    // DailyBonus
    _b[PHRASES.DailyBonus] = 'Daily Bonus',
    _b[PHRASES.Come_back] = 'Come back to the game tomorrow to get a bonus.',
    _b[PHRASES.Try_again] = 'Try again',
    _b[PHRASES.You_have_daily_bonus] = 'A bonus is available to you for regular entry into the game. Would you like to see?',
    _b[PHRASES.Take] = 'Take',
    _b[PHRASES.You_have_access_to_bonus_for_x_days] = 'You have access to a bonus for $1.',
    _b[PHRASES.DaysPlural] = 'day|days|days',
    _b[PHRASES.Ok] = 'Ok',
    _b[PHRASES.Store] = 'Store',
    _b[PHRASES.Rewarded_video] = 'Rewarded video.',
    _b[PHRASES.Settings] = 'Settings',
    _b[PHRASES.VERSION] = 'VERSION',
    _b[PHRASES.Show_rv] = 'Show rwarded video',
    _b[PHRASES.Please_try_again_later] = 'Please try again later.',
    _b[PHRASES.SMALL_SCREEN] = ['Sorry! Need a', 'bigger screen.'],
    _b[PHRASES.native_timer_text] = 'Ad in $t sec.',
    _b);
// Переводчик № 1: https://kwork.ru/user/kuzhnaeva-777
// Переводчик № 2: https://kwork.ru/user/krasilexis_20
var es = (_c = {},
    _c[PHRASES.New_Game] = 'Juego nuevo',
    _c[PHRASES.Continue] = 'Continuer',
    _c[PHRASES.Learning] = 'Entrenamiento',
    _c[PHRASES.step] = 'paso',
    _c[PHRASES.of] = 'de',
    _c[PHRASES.Excellent] = 'Es genial',
    _c[PHRASES.Line_up_the_puzzle_horizontally] = 'Reúna una línea horizontal.',
    _c[PHRASES.Line_up_the_puzzle_vertically] = 'Reúne una línea vertical.',
    _c[PHRASES.Make_a_square] = 'Recoge un cuadrado.',
    _c[PHRASES.CLICK_TO_SHAPE] = 'Gire la figura haciendo clic en ella.',
    _c[PHRASES.You_are_ready_to_play] = 'Estás listo para jugar.',
    _c[PHRASES.MOVE_SHAPES_TO_GOOD_SCORE] = 'Para anotar más puntos, arrastra tantas piezas como sea posible al campo de juego.',
    _c[PHRASES.OCCUPIED_CELLS_ARE_VACATED] = 'Las celdas ocupadas se liberan cuando se llena una línea vertical/ horizontal o uno de los 9 cuadrados.',
    _c[PHRASES.SHAPES_CAN_BE_TURNED] = 'Las figuras se pueden girar haciendo clic en ellas.',
    _c[PHRASES.Play] = 'Jugar',
    _c[PHRASES.Block_Puzzle] = 'Rompecabezas de bloques',
    _c[PHRASES.The_hints_are_over] = 'Se acabaron los consejos.',
    _c[PHRASES.COME_BACK_FOR_BONUS] = 'Regrese al juego mañana para obtener un bono.',
    _c[PHRASES.BONUS_ACCRUED] = 'Se ha acreditado un bono de %bonus% pistas por la entrada diaria regular en el juego.',
    _c[PHRASES.New_Record] = 'Un nuevo record',
    _c[PHRASES.NEW_RECORD] = 'UN NUEVO RECORD',
    _c[PHRASES.Score] = 'Puntos',
    _c[PHRASES.video] = 'video',
    _c[PHRASES.Color_Theme] = 'Tema',
    _c[PHRASES.Language] = 'Idioma',
    _c[PHRASES.Global_Rating] = 'Calificación general',
    _c[PHRASES.Sound_Effects] = 'Efectos de sonido',
    _c[PHRASES.ComboAnimations] = 'Animaciones (Combo/Serie)',
    _c[PHRASES.CancelMoveFeature] = 'Función de deshacer',
    _c[PHRASES.CancelMove] = 'Cancelar movimiento',
    _c[PHRASES.theme_default] = 'Estándar',
    _c[PHRASES.theme_old_school] = 'Vieja escuela',
    _c[PHRASES.theme_night] = 'Noche',
    _c[PHRASES.theme_instagram] = 'Instagram',
    _c[PHRASES.theme_green_lantern] = 'Linterna verde',
    _c[PHRASES.theme_white] = 'Luz',
    // [PHRASES.invite_friends]: 'Invitar a amigos',
    _c[PHRASES.Friends_achievements] = 'Logros de amigos',
    _c[PHRASES.lang_ru] = 'Russian',
    _c[PHRASES.lang_en] = 'English',
    _c[PHRASES.lang_tr] = 'Turkish',
    _c[PHRASES.lang_es] = 'Spanish',
    _c[PHRASES.lang_de] = 'Deutsch',
    _c[PHRASES.lang_hi] = 'Hindi',
    _c[PHRASES.Rating] = 'Calificación',
    _c[PHRASES.Loading] = 'Cargando',
    _c[PHRASES.Something_went_wrong] = 'Algo salió mal.',
    _c[PHRASES.Authorization_required_in_rating] = 'Para ver la calificación es necesario iniciar sesión.',
    _c[PHRASES.Login] = 'Iniciar sesión',
    _c[PHRASES.Anonymous_player] = 'Anónimo',
    _c[PHRASES.Try_again] = 'Intentar otra vez',
    _c[PHRASES.You_can_cancel_moves_for_rw] = 'Puede deshacer varios movimientos para ver un video promocional.',
    _c[PHRASES.You_can_cancel_this_move_for_rw] = 'Puede cancelar este movimiento para ver el video promocional.',
    _c[PHRASES.You_can_cancel_this_move_for_coins] = 'Puedes cancelar este movimiento por $1 monedas.',
    // [PHRASES.You_can_get_coins_for_rv]:
    //   'No hay suficientes monedas para cancelar el movimiento. Puedes conseguir monedas extra viendo el vídeo promocional.',
    _c[PHRASES.You_need_replenish_balance] = 'Debe reponer el saldo para usar las funciones de deshacer o sugerencia.',
    _c[PHRASES.No_RW_message] = 'Lo sentimos. Actualmente no hay videos promocionales disponibles.',
    _c[PHRASES.Close_after_x_sec] = 'Cierra en $1 segundos.',
    _c[PHRASES.Last_x_moves_canceled] = 'Los últimos $1 movimientos han sido cancelados.',
    _c[PHRASES.All_time_record] = 'Todo el tiempo',
    _c[PHRASES.Combo_x] = 'Combo $1x!',
    _c[PHRASES.Series_x] = 'Series $1x!',
    _c[PHRASES.HIGH_SCORE_1] = 'RÉCORD ABSOLUTO',
    _c[PHRASES.HIGH_SCORE_2] = '',
    _c[PHRASES.HIGH_SCORE_TODAY_1] = 'EL MEJOR RESULTADO DE HOY',
    _c[PHRASES.HIGH_SCORE_TODAY_2] = '',
    _c[PHRASES.Cancel] = 'Cancelar',
    _c[PHRASES.Close] = 'Cerar',
    _c[PHRASES.You_can_get_hint_for_rw] = 'Puede obtener sugerencias adicionales para ver el video promocional.',
    _c[PHRASES.Bonus_x_hints] = 'Bono: $1 tip',
    _c[PHRASES.Bonus_x_coins] = 'Bono: $1 monedas',
    // DailyBonus
    _c[PHRASES.DailyBonus] = 'Bonus diario',
    _c[PHRASES.Come_back] = 'Vuelva al juego mañana para obtener un bono.',
    // [PHRASES.Try_again]: 'intentar otra vez',
    _c[PHRASES.You_have_daily_bonus] = 'Una bonificación está disponible para usted por la entrada regular en el juego. ¿Te gustaría ver?',
    _c[PHRASES.Take] = 'Tomar',
    _c[PHRASES.You_have_access_to_bonus_for_x_days] = 'Tienes acceso a un bono por $1.',
    _c[PHRASES.DaysPlural] = 'día|días|días',
    _c[PHRASES.Ok] = 'OK',
    _c[PHRASES.Store] = 'Comercio',
    _c[PHRASES.Rewarded_video] = 'Vídeo premiado.',
    _c[PHRASES.Settings] = 'Ajustes',
    _c[PHRASES.VERSION] = 'VERSIÓN',
    _c[PHRASES.Show_rv] = 'Mostrar vídeo premiado',
    _c[PHRASES.Please_try_again_later] = 'Por favor, inténtelo de nuevo más tarde.',
    _c[PHRASES.SMALL_SCREEN] = ['¡Lo siento! Necesita', 'una pantalla más grande.'],
    _c[PHRASES.native_timer_text] = 'Anuncio en $t seg.',
    _c);
// Переводчик № 1: https://kwork.ru/user/sanem
// Переводчик № 2: https://kwork.ru/user/muminagunaydin
var tr = (_d = {},
    _d[PHRASES.New_Game] = 'Yeni oyun',
    _d[PHRASES.Continue] = 'Devam et',
    _d[PHRASES.Learning] = 'Eğitim',
    _d[PHRASES.step] = 'adım',
    _d[PHRASES.of] = '/',
    _d[PHRASES.Excellent] = 'Mükemmel',
    _d[PHRASES.Line_up_the_puzzle_horizontally] = 'Yatay bir çizgi toplayın.',
    _d[PHRASES.Line_up_the_puzzle_vertically] = 'Dikey bir çizgi toplayın.',
    _d[PHRASES.Make_a_square] = 'Kare toplayın.',
    _d[PHRASES.CLICK_TO_SHAPE] = 'Üzerine tıklayarak şekli döndürün.',
    _d[PHRASES.You_are_ready_to_play] = 'Oyuna hazırsınız.',
    _d[PHRASES.MOVE_SHAPES_TO_GOOD_SCORE] = 'Daha fazla puan kazanmak için oyun alanına mümkün olduğunca çok figür sürükleyin.',
    _d[PHRASES.OCCUPIED_CELLS_ARE_VACATED] = 'İşgal edilmiş kareler, dikey/yatay bir çizgi veya 9 kareden biri doldurulduğunda boşaltılır.',
    _d[PHRASES.SHAPES_CAN_BE_TURNED] = 'Şekiller üzerlerine tıklanarak döndürülebilir.',
    _d[PHRASES.Play] = 'Oyna',
    _d[PHRASES.Block_Puzzle] = 'Block Puzzle',
    _d[PHRASES.The_hints_are_over] = 'İpuçları bitti.',
    _d[PHRASES.COME_BACK_FOR_BONUS] = 'Bonus almak için yarın oyuna tekrar gelin.',
    _d[PHRASES.BONUS_ACCRUED] = 'Oyuna düzenli günlük giriş için %bonus% ipucu bonusu eklendi.',
    _d[PHRASES.New_Record] = 'Yeni Rekor',
    _d[PHRASES.NEW_RECORD] = 'YENI REKOR',
    _d[PHRASES.Score] = 'Hesap',
    _d[PHRASES.video] = 'video',
    _d[PHRASES.Color_Theme] = 'Başlık',
    _d[PHRASES.Language] = 'Dil',
    _d[PHRASES.Global_Rating] = 'Genel Değerlendirme',
    _d[PHRASES.Sound_Effects] = 'Ses efektleri',
    _d[PHRASES.ComboAnimations] = 'Animasyonlar (Kombo/Seri)',
    _d[PHRASES.CancelMoveFeature] = 'Hamleyi iptal et',
    _d[PHRASES.CancelMove] = 'Taşımayı geri al',
    _d[PHRASES.theme_default] = 'Standart',
    _d[PHRASES.theme_old_school] = 'Eski okul',
    _d[PHRASES.theme_night] = 'Gece',
    _d[PHRASES.theme_instagram] = 'Instagram',
    _d[PHRASES.theme_green_lantern] = 'Yeşil ışık',
    _d[PHRASES.theme_white] = 'Aydın',
    // [PHRASES.invite_friends]: 'Arkadaşları davet et',
    _d[PHRASES.Friends_achievements] = 'Arkadaşlar Başarılar',
    _d[PHRASES.lang_ru] = 'Russian',
    _d[PHRASES.lang_en] = 'English',
    _d[PHRASES.lang_tr] = 'Turkish',
    _d[PHRASES.lang_es] = 'Spanish',
    _d[PHRASES.lang_de] = 'Deutsch',
    _d[PHRASES.lang_hi] = 'Hindi',
    _d[PHRASES.Rating] = 'Değerlendirme',
    _d[PHRASES.Loading] = 'Yükleniyor',
    _d[PHRASES.Something_went_wrong] = 'Bir şeyler yanlış gitti.',
    _d[PHRASES.Authorization_required_in_rating] = 'Derecelendirmeleri görüntülemek için üyelik gereklidir.',
    _d[PHRASES.Login] = 'Giriş yap',
    _d[PHRASES.Anonymous_player] = 'İsimsiz oyuncu',
    // [PHRASES.Try_again]: 'Tekrar dene',
    _d[PHRASES.You_can_cancel_moves_for_rw] = 'Bir tanıtım videosunu izlemek için birden fazla hareketi geri alabilirsiniz.',
    _d[PHRASES.You_can_cancel_this_move_for_rw] = 'Tanıtım videosunu izleyerek son hamleyi iptal edebilirsiniz.',
    _d[PHRASES.You_can_cancel_this_move_for_coins] = 'Bu hareketi $1 jeton karşılığında iptal edebilirsiniz.',
    // [PHRASES.You_can_get_coins_for_rv]:
    //   'Hareketi iptal etmek için yeterli para yok. Tanıtım videosunu izleyerek ekstra para kazanabilirsiniz.',
    _d[PHRASES.You_need_replenish_balance] = 'Geri alma veya ipucu işlevlerini kullanmak için bakiyeyi yenilemeniz gerekir.',
    _d[PHRASES.No_RW_message] = 'Üzgünüz. Şu anda tanıtım videosu bulunmamaktadır.',
    _d[PHRASES.Close_after_x_sec] = '$1 saniye sonra kapanır.',
    _d[PHRASES.Last_x_moves_canceled] = 'Son $1 hamle iptal edildi.',
    _d[PHRASES.All_time_record] = 'TÜM ZAMANLAR',
    _d[PHRASES.Combo_x] = 'Kombo $1x!',
    _d[PHRASES.Series_x] = '$1x serisi!',
    _d[PHRASES.HIGH_SCORE_1] = 'MUTLAK REKOR',
    _d[PHRASES.HIGH_SCORE_2] = '',
    _d[PHRASES.HIGH_SCORE_TODAY_1] = 'BUGÜN İÇİN EN İYİ SONUÇ',
    _d[PHRASES.HIGH_SCORE_TODAY_2] = '',
    _d[PHRASES.Cancel] = 'İptal',
    _d[PHRASES.Close] = 'Kapat',
    _d[PHRASES.You_can_get_hint_for_rw] = 'Tanıtım videosunu izlemek için ek ipuçları alabilirsiniz.',
    _d[PHRASES.Bonus_x_hints] = 'Bonus: $1 ipucu.',
    _d[PHRASES.Bonus_x_coins] = 'Bonus: $1 jeton',
    // DailyBonus
    _d[PHRASES.DailyBonus] = 'Günlük bonus',
    _d[PHRASES.Come_back] = 'Bir bonus almak için yarın oyuna tekrar gelin.',
    _d[PHRASES.Try_again] = 'Tekrar deneyin',
    _d[PHRASES.You_have_daily_bonus] = 'Oyuna düzenli giriş için size bir bonus verilir. Görmek ister misin?',
    _d[PHRASES.Take] = 'Almak',
    _d[PHRASES.You_have_access_to_bonus_for_x_days] = '$1 bir bonusa erişiminiz var.',
    _d[PHRASES.DaysPlural] = 'gün|günler|günler',
    _d[PHRASES.Ok] = 'TAMAM',
    _d[PHRASES.Store] = 'Mağaza',
    _d[PHRASES.Rewarded_video] = 'ödüllü video',
    _d[PHRASES.Settings] = 'Ayarlar',
    _d[PHRASES.VERSION] = 'VERSİYON',
    _d[PHRASES.Show_rv] = 'Reklamları izlemek',
    _d[PHRASES.Please_try_again_later] = 'Tekrar dene.',
    _d[PHRASES.SMALL_SCREEN] = ['Üzgünüm! Daha büyük', 'bir ekrana ihtiyacınız var.'],
    _d[PHRASES.native_timer_text] = '$t saniyede reklam.',
    _d);
var de = (_e = {},
    _e[PHRASES.New_Game] = 'Neues Spiel',
    _e[PHRASES.Continue] = 'Fortfahren',
    _e[PHRASES.Learning] = 'Schulung',
    _e[PHRASES.step] = 'Schritt',
    _e[PHRASES.of] = 'von',
    _e[PHRASES.Excellent] = 'Exzellent',
    _e[PHRASES.Line_up_the_puzzle_horizontally] = 'Sammeln Sie eine horizontale Linie.',
    _e[PHRASES.Line_up_the_puzzle_vertically] = 'Sammeln Sie eine vertikale Linie.',
    _e[PHRASES.Make_a_square] = 'Setze das Quadrat zusammen.',
    _e[PHRASES.CLICK_TO_SHAPE] = 'Drehen Sie die Form, indem Sie darauf klicken.',
    _e[PHRASES.You_are_ready_to_play] = 'Sie sind bereit zu spielen.',
    _e[PHRASES.MOVE_SHAPES_TO_GOOD_SCORE] = 'Um mehr Punkte zu erzielen, ziehen Sie so viele Figuren wie möglich auf das Spielfeld.',
    _e[PHRASES.OCCUPIED_CELLS_ARE_VACATED] = 'Besetzte Zellen werden freigegeben, wenn eine vertikale/horizontale Linie oder eines der 9 Quadrate gefüllt ist.',
    _e[PHRASES.SHAPES_CAN_BE_TURNED] = 'Figuren können durch Anklicken gedreht werden.',
    _e[PHRASES.Play] = 'Spielen',
    _e[PHRASES.Block_Puzzle] = 'Block Puzzle',
    _e[PHRASES.The_hints_are_over] = 'Tipps sind vorbei.',
    _e[PHRASES.COME_BACK_FOR_BONUS] = 'Kommen Sie morgen zum Spiel zurück, um einen Bonus zu erhalten.',
    _e[PHRASES.BONUS_ACCRUED] = 'Ein Bonus von %bonus% Tipps wurde für den regelmäßigen täglichen Eintritt in das Spiel hinzugefügt.',
    _e[PHRASES.New_Record] = 'Neuer Rekord',
    _e[PHRASES.NEW_RECORD] = 'NEUER REKORD',
    _e[PHRASES.Score] = 'Spielstand',
    _e[PHRASES.video] = 'video',
    _e[PHRASES.Color_Theme] = 'Thema',
    _e[PHRASES.Language] = 'Sprache',
    _e[PHRASES.Global_Rating] = 'Gesamtwertung',
    _e[PHRASES.Sound_Effects] = 'Soundeffekte',
    _e[PHRASES.ComboAnimations] = 'Animationen (Combo/Serie)',
    _e[PHRASES.CancelMoveFeature] = 'Funktion rückgängig',
    _e[PHRASES.CancelMove] = 'Umzug abbrechen',
    _e[PHRASES.theme_default] = 'Standard',
    _e[PHRASES.theme_old_school] = 'Alte Schule',
    _e[PHRASES.theme_night] = 'Nacht',
    _e[PHRASES.theme_instagram] = 'Instagram',
    _e[PHRASES.theme_green_lantern] = 'Grüne Laterne',
    _e[PHRASES.theme_white] = 'Licht',
    // [PHRASES.invite_friends]: 'Freunde einladen',
    _e[PHRASES.Friends_achievements] = 'Freunde Erfolge',
    _e[PHRASES.lang_ru] = 'Russian',
    _e[PHRASES.lang_en] = 'English',
    _e[PHRASES.lang_tr] = 'Turkish',
    _e[PHRASES.lang_es] = 'Spanish',
    _e[PHRASES.lang_de] = 'Deutsch',
    _e[PHRASES.lang_hi] = 'Hindi',
    _e[PHRASES.Rating] = 'Spieler bewerten',
    _e[PHRASES.Loading] = 'Wird geladen',
    _e[PHRASES.Something_went_wrong] = 'Etwas ist schief gelaufen.',
    _e[PHRASES.Authorization_required_in_rating] = 'Um die Bewertung anzuzeigen, müssen Sie sich anmelden.',
    _e[PHRASES.Login] = 'Betreten',
    _e[PHRASES.Anonymous_player] = 'anonymer Spieler',
    // [PHRASES.Try_again]: 'Wiederholen',
    _e[PHRASES.You_can_cancel_moves_for_rw] = 'You can undo multiple moves by watching a promotional video.',
    _e[PHRASES.You_can_cancel_this_move_for_rw] = 'Sie können diesen Schritt abbrechen wenn Sie ein Werbevideo ansehen.',
    _e[PHRASES.You_can_cancel_this_move_for_coins] = 'Sie können diesen Zug für $1 Münzen abbrechen.',
    // [PHRASES.You_can_get_coins_for_rv]:
    //   'Nicht genug Münzen, um den Zug abzubrechen. Sie können zusätzliche Münzen erhalten, indem Sie sich das Werbevideo ansehen.',
    _e[PHRASES.You_need_replenish_balance] = 'Sie müssen das Guthaben auffüllen, um die Rückgängig- oder Hinweisfunktionen nutzen zu können.',
    _e[PHRASES.No_RW_message] = 'Entschuldigung. Derzeit sind keine Werbevideos verfügbar.',
    _e[PHRASES.Close_after_x_sec] = 'Schließt nach $1 Sekunden.',
    _e[PHRASES.Last_x_moves_canceled] = 'The last $1 moves have been canceled.',
    _e[PHRASES.All_time_record] = 'Die Ganze Zeit',
    _e[PHRASES.Combo_x] = 'Kombo $1x!',
    _e[PHRASES.Series_x] = 'Serie $1x!',
    _e[PHRASES.HIGH_SCORE_1] = 'ABSOLUTER REKORD',
    _e[PHRASES.HIGH_SCORE_2] = '',
    _e[PHRASES.HIGH_SCORE_TODAY_1] = 'BESTE ERGEBNISSE FÜR HEUTE',
    _e[PHRASES.HIGH_SCORE_TODAY_2] = '',
    _e[PHRASES.Cancel] = 'Absagen',
    _e[PHRASES.Close] = 'Schließen',
    _e[PHRASES.You_can_get_hint_for_rw] = 'Sie können zusätzliche Hinweise erhalten wenn Sie ein Werbevideos ansehen.',
    _e[PHRASES.Bonus_x_hints] = 'Bonus: $1 Hinweise',
    _e[PHRASES.Bonus_x_coins] = 'Bonus: $1 Münzen',
    // DailyBonus
    _e[PHRASES.DailyBonus] = 'Täglicher Bonus',
    _e[PHRASES.Come_back] = 'Kommen Sie morgen zum Spiel zurück, um einen Bonus zu erhalten.',
    _e[PHRASES.Try_again] = 'Wiederholen',
    _e[PHRASES.You_have_daily_bonus] = 'Für den regulären Eintritt in das Spiel steht Ihnen ein Bonus zur Verfügung. Würdest du gerne sehen?',
    _e[PHRASES.Take] = 'Nehmen',
    _e[PHRASES.You_have_access_to_bonus_for_x_days] = 'Sie erhalten einen Bonus für $1',
    _e[PHRASES.DaysPlural] = 'Tag|Tage|Tage',
    _e[PHRASES.Ok] = 'OK',
    _e[PHRASES.Store] = 'Geschäft',
    _e[PHRASES.Rewarded_video] = 'belohntes Video',
    _e[PHRASES.Settings] = 'Einstellungen',
    _e[PHRASES.VERSION] = 'AUSFÜHRUNG',
    _e[PHRASES.Show_rv] = 'Prämiertes Video anzeigen',
    _e[PHRASES.Please_try_again_later] = 'Bitte versuchen Sie es später noch einmal.',
    _e[PHRASES.SMALL_SCREEN] = ['Entschuldigung! Brauche', 'einen größeren Bildschirm.'],
    _e[PHRASES.native_timer_text] = 'Anzeige in $t Sek.',
    _e);
// Devanagari - алфавит, используемый для санскрита, хинди и других индийских языков.
var hi = (_f = {},
    _f[PHRASES.New_Game] = 'नया खेल',
    _f[PHRASES.Continue] = 'जारी रखना',
    _f[PHRASES.Learning] = 'सीखना',
    _f[PHRASES.step] = 'चरण',
    _f[PHRASES.of] = 'में से',
    _f[PHRASES.Excellent] = 'उत्कृष्ट',
    _f[PHRASES.Line_up_the_puzzle_horizontally] = 'पहेली को क्षैतिज रूप से पंक्तिबद्ध करें',
    _f[PHRASES.Line_up_the_puzzle_vertically] = 'एक लंबवत रेखा इकट्ठा करें',
    _f[PHRASES.Make_a_square] = 'चौक को इकट्ठा करो',
    _f[PHRASES.CLICK_TO_SHAPE] = 'उस पर क्लिक करके आकृति को घुमाएं',
    _f[PHRASES.You_are_ready_to_play] = 'आप खेलने के लिए तैयार हैं',
    _f[PHRASES.MOVE_SHAPES_TO_GOOD_SCORE] = 'अधिक अंक प्राप्त करने के लिए, खेल मैदान पर जितना संभव हो उतने आंकड़े खींचें',
    _f[PHRASES.OCCUPIED_CELLS_ARE_VACATED] = 'जब एक लंबवत/क्षैतिज रेखा या 9 वर्गों में से एक भर जाता है तो अधिकृत कोशिकाएं जारी की जाती हैं',
    _f[PHRASES.SHAPES_CAN_BE_TURNED] = 'उन पर क्लिक करके आंकड़े घुमाए जा सकते हैं',
    _f[PHRASES.Play] = 'खेलें',
    _f[PHRASES.Block_Puzzle] = 'ब्लॉक पहेली',
    _f[PHRASES.The_hints_are_over] = 'युक्तियाँ समाप्त हो गई हैं',
    _f[PHRASES.COME_BACK_FOR_BONUS] = 'बोनस पाने के लिए कल खेल में वापस आएं',
    _f[PHRASES.BONUS_ACCRUED] = 'खेल में नियमित दैनिक प्रवेश के लिए %bonus% युक्तियों का बोनस जोड़ा गया है',
    _f[PHRASES.New_Record] = 'नया रिकॉर्ड',
    _f[PHRASES.NEW_RECORD] = 'नया रिकॉर्ड',
    _f[PHRASES.Score] = 'जांच',
    _f[PHRASES.video] = 'वीडियो',
    _f[PHRASES.Color_Theme] = 'विषय',
    _f[PHRASES.Language] = 'भाषा',
    _f[PHRASES.Global_Rating] = 'समग्र रेटिंग',
    _f[PHRASES.Sound_Effects] = 'ध्वनि प्रभाव',
    _f[PHRASES.ComboAnimations] = 'एनिमेशन (कॉम्बो/श्रृंखला)',
    _f[PHRASES.CancelMoveFeature] = 'समारोह पूर्ववत करें',
    _f[PHRASES.CancelMove] = 'स्थानांतरण रद्द करें',
    _f[PHRASES.theme_default] = 'मानक',
    _f[PHRASES.theme_old_school] = 'पुराना स्कूल',
    _f[PHRASES.theme_night] = 'रात',
    _f[PHRASES.theme_instagram] = 'Instagram',
    _f[PHRASES.theme_green_lantern] = 'हरा लालटेन',
    _f[PHRASES.theme_white] = 'रोशनी',
    // [PHRASES.invite_friends]: 'मित्रों को आमंत्रित करें',
    _f[PHRASES.Friends_achievements] = 'मित्र उपलब्धियां',
    _f[PHRASES.lang_ru] = 'Russian',
    _f[PHRASES.lang_en] = 'English',
    _f[PHRASES.lang_tr] = 'Turkish',
    _f[PHRASES.lang_es] = 'Spanish',
    _f[PHRASES.lang_de] = 'Deutsch',
    _f[PHRASES.lang_hi] = 'Hindi',
    _f[PHRASES.Rating] = 'रेटिंग',
    _f[PHRASES.Loading] = 'लोड हो रहा है',
    _f[PHRASES.Something_went_wrong] = 'कुछ गलत हो गया',
    _f[PHRASES.Authorization_required_in_rating] = 'रेटिंग देखने के लिए आपको लॉग इन करना होगा।',
    _f[PHRASES.Login] = 'आने के लिए',
    _f[PHRASES.Anonymous_player] = 'बेनामी खिलाड़ी',
    // [PHRASES.Try_again]: 'दोहराना',
    _f[PHRASES.You_can_cancel_moves_for_rw] = 'आप एक प्रचार वीडियो देखकर कई चालों को पूर्ववत कर सकते हैं',
    _f[PHRASES.You_can_cancel_this_move_for_rw] = 'प्रचार वीडियो देखने के लिए आप इस कदम को रद्द कर सकते हैं',
    _f[PHRASES.You_can_cancel_this_move_for_coins] = 'आप इस कदम को $1 सिक्कों के लिए रद्द कर सकते हैं',
    // [PHRASES.You_can_get_coins_for_rv]:
    //   'चाल को रद्द करने के लिए पर्याप्त सिक्के नहीं हैं। प्रचार वीडियो देखकर आप अतिरिक्त सिक्के प्राप्त कर सकते हैं',
    _f[PHRASES.You_need_replenish_balance] = 'पूर्ववत या संकेत कार्यों का उपयोग करने के लिए आपको शेष राशि को फिर से भरने की आवश्यकता है।',
    _f[PHRASES.No_RW_message] = 'माफ़ करना। वर्तमान में कोई प्रचार वीडियो उपलब्ध नहीं है',
    _f[PHRASES.Close_after_x_sec] = '$1 सेकंड के बाद बंद हो जाता है',
    _f[PHRASES.Last_x_moves_canceled] = 'अंतिम $1 चालें रद्द कर दी गई हैं',
    _f[PHRASES.All_time_record] = 'पूरा समय',
    _f[PHRASES.Combo_x] = 'कॉम्बो $1x!',
    _f[PHRASES.Series_x] = 'सीरीज $1x!',
    _f[PHRASES.HIGH_SCORE_1] = 'नया पूर्ण रिकॉर्ड',
    _f[PHRASES.HIGH_SCORE_2] = '',
    _f[PHRASES.HIGH_SCORE_TODAY_1] = 'आज के सर्वश्रेष्ठ परिणाम',
    _f[PHRASES.HIGH_SCORE_TODAY_2] = '',
    _f[PHRASES.Cancel] = 'रद्द करना',
    _f[PHRASES.Close] = 'बंद करना',
    _f[PHRASES.You_can_get_hint_for_rw] = 'प्रचार वीडियो देखने के लिए आप इस कदम को रद्द कर सकते हैं',
    _f[PHRASES.Bonus_x_hints] = 'बोनस: $1 संकेत',
    _f[PHRASES.Bonus_x_coins] = 'बोनस: $1 सिक्के',
    // DailyBonus
    _f[PHRASES.DailyBonus] = 'प्रतिदिन लाभ',
    _f[PHRASES.Come_back] = 'बोनस पाने के लिए कल खेल में वापस आएं',
    _f[PHRASES.Try_again] = 'पुनः प्रयास करें',
    _f[PHRASES.You_have_daily_bonus] = 'खेल में नियमित प्रवेश के लिए आपके लिए एक बोनस उपलब्ध है। क्या आप देखना चाहेंगे?',
    _f[PHRASES.Take] = 'लेना',
    _f[PHRASES.You_have_access_to_bonus_for_x_days] = 'आपके पास $1 के लिए बोनस तक पहुंच है।',
    _f[PHRASES.DaysPlural] = 'दिन|दिन|दिन',
    _f[PHRASES.Ok] = 'ठीक है',
    _f[PHRASES.Store] = 'दुकान',
    _f[PHRASES.Rewarded_video] = 'पुरस्कृत वीडियो',
    _f[PHRASES.Settings] = 'समायोजन',
    _f[PHRASES.VERSION] = 'संस्करण',
    _f[PHRASES.Show_rv] = 'पुरस्कृत वीडियो दिखाएँ',
    _f[PHRASES.Please_try_again_later] = 'कृपया बाद में पुन: प्रयास करें।',
    _f[PHRASES.SMALL_SCREEN] = ['क्षमा मांगना!', 'बड़ी स्क्रीन चाहिए.'],
    _f[PHRASES.native_timer_text] = '$t सेकंड में विज्ञापन.',
    _f);
var dictionary = IS_ULTRA ? { ru: ru, en: en } : { ru: ru, en: en, es: es, tr: tr, de: de, hi: hi };
var lang = 'ru';
export var setLang = function (l) { return (lang = l); };
export var getLang = function () { return lang; };
export var isRu = function () { return lang === 'ru'; };
export var t = function (phrase, vars) {
    if (dictionary[lang] && dictionary[lang][phrase])
        return r(dictionary[lang][phrase], vars);
    if (DEVELOPMENT)
        console.warn('Нет перевода для:', phrase);
    if (dictionary['en'] && dictionary['en'][phrase])
        return r(dictionary['en'][phrase], vars);
    return '';
};
export var r = function (text, vars) {
    if (vars && vars.length)
        vars.forEach(function (v, i) { return (text = text.replace("$".concat(i + 1), v)); });
    return text;
};
if (DEVELOPMENT) {
    var ln_1 = function (lang) { return Object.keys(dictionary[lang]).length; };
    var fastCheck = Object.keys(dictionary).reduce(function (check, lang, i, arr) {
        if (i > 0) {
            var firstLang = arr[0];
            if (ln_1(lang) !== ln_1(firstLang)) {
                check = false;
            }
        }
        return check;
    }, true);
    if (!fastCheck) {
        var check_1 = function (name) {
            Object.keys(PHRASES)
                .filter(function (key) { return /[A-z]/.test(key); })
                .forEach(function (key) {
                if (dictionary[name][eval("PHRASES.".concat(key))] === undefined) {
                    console.warn("\u041D\u0435\u0442 \u043A\u043B\u044E\u0447\u0430 \"".concat(key, "\" \u0432 \u0441\u043B\u043E\u0432\u0430\u0440\u0435 \"").concat(name, "\"!"));
                }
            });
        };
        Object.keys(dictionary).forEach(function (lang) { return check_1(lang); });
    }
}
